module.exports = __webpack_public_path__ + "static/media/trending-icon.11810858.svg";